import clsx from "clsx";
import { motion } from "framer-motion";
import Image from "next/image";
import React, { useState } from "react";

import { GoogleTagManagerEvents } from "../../../common";
import { BlackSimpleArrow, CloseIcon } from "../../../public/Theme";
import NewPrimaryButton from "../../Atoms/Buttons/NewPrimaryButton";
import HeaderLinkWithIcon from "../../Atoms/Typography/HeaderLinkWithIcon";
import SideNavbarSections from "../../Molecules/SideNavbarSections";
import CurrencySelectorDropdown from "../CurrencySelectorDropdown";
import {
    BACK_TEXT,
    CLOSE_ICON_ALT,
    DRAWER_NAVIGATION,
    LAZY,
    NewHeaderLinks,
} from "./constants";
import { FRONTEND_ENDPOINTS } from "@/public/Constants/endpoints";
import { usePathname } from "next/navigation";

const MenuLandingTabs = ({
    drawerOpen,
    setDrawerOpen,
    setSectionLinks,
    activeTab,
    setActiveTab,
}) => {
    return (
        <div>
            <div className="!h-10">
                <NewPrimaryButton
                    event={GoogleTagManagerEvents.navigationInteractions}
                    place="header"
                    menuName={"header navigation menu"}
                    className=" w-full justify-center my-[22px] "
                    text={"take your style quiz"}
                    href={FRONTEND_ENDPOINTS?.BOX_SIGNUP}
                    onClick={() => setDrawerOpen(!drawerOpen)}
                />
            </div>

            <div className="mt-5 relative flex justify-between border-b-2 border-gray-200">
                {NewHeaderLinks?.map((tab, index) => (
                    <button
                        key={index + tab?.title}
                        onClick={() => setActiveTab(tab)}
                        className={clsx(
                            "relative flex-1 text-center text-[13px] py-3 font-medium transition-colors duration-200"
                        )}
                    >
                        {tab?.title}
                        {activeTab?.title === tab?.title && (
                            <motion.div
                                layoutId="underline"
                                className="absolute -bottom-[2px] left-0 right-0 h-[2px] bg-black"
                                transition={{
                                    type: "spring",
                                    stiffness: 300,
                                    damping: 30,
                                }}
                            />
                        )}
                    </button>
                ))}
            </div>
            <div className="mb-5 overflow-y-none">
                <ul className="">
                    {activeTab?.options?.map((item, index) => (
                        <li key={index}>
                            <HeaderLinkWithIcon
                                icon={item?.image}
                                text={item?.text}
                                flyoutLinks={item?.flyout_links}
                                link={item?.link}
                                setSectionLinks={setSectionLinks}
                                onClick={() => setDrawerOpen(!drawerOpen)}
                            />
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

const MobileSideMenu = ({ drawerOpen, setDrawerOpen }) => {
    const pathname = usePathname();
    const [sectionLinks, setSectionLinks] = useState(null);
    const [activeTab, setActiveTab] = useState(
        pathname?.includes?.("shop")
            ? NewHeaderLinks?.[1]
            : NewHeaderLinks?.[0] || {}
    );

    return (
        <>
            <div className="flex flex-row justify-between items-center w-full">
                {sectionLinks ? (
                    <div>
                        <button
                            className={`flex justify-center items-center font-Montserrat font-bold text-sm`}
                            onClick={() => {
                                setSectionLinks(null);
                            }}
                        >
                            <Image
                                src={BlackSimpleArrow}
                                width={14}
                                height={14}
                                className="rotate-180 mr-2"
                                alt={"Back button"}
                            />
                            {BACK_TEXT}
                        </button>
                    </div>
                ) : (
                    <CurrencySelectorDropdown />
                )}

                <button
                    data-drawer-dismiss={DRAWER_NAVIGATION}
                    aria-controls={DRAWER_NAVIGATION}
                    onClick={() => setDrawerOpen(!drawerOpen)}
                    className="bg-transparent rounded-lg "
                >
                    <Image
                        width={25}
                        height={25}
                        src={CloseIcon}
                        alt={CLOSE_ICON_ALT}
                        loading={LAZY}
                    />
                </button>
            </div>

            {!sectionLinks ? (
                <MenuLandingTabs
                    drawerOpen={drawerOpen}
                    setDrawerOpen={setDrawerOpen}
                    setSectionLinks={setSectionLinks}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                />
            ) : (
                <SideNavbarSections
                    links={sectionLinks}
                    onClick={() => {
                        setSectionLinks(null);
                        setDrawerOpen(!drawerOpen);
                    }}
                />
            )}
            <div
                className="flex-1"
                onClick={() => {
                    setSectionLinks(null);
                    setDrawerOpen(!drawerOpen);
                }}
            />
        </>
    );
};

export default MobileSideMenu;
